import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import componentStyles from './ghs-tab-link.css.lit';

/**
 * The GHS tab link component
 *
 * @element ghs-tab-link
 */
@customElement('ghs-tab-link')
export class GhsTabLink extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * The label text.
   * @param label
   */
  @property({ type: String })
  label = '';

  /**
   * Whether the panel is active/open.
   * Controlled by parent ghs-tabs component.
   */
  @property({ type: Boolean, reflect: true })
  active = false;

  /**
   * Whether the panel is active/open.
   * Controlled by parent ghs-tabs component.
   */
  @property({ type: String })
  url = '';

  /**
   * Used to provided a unique ID
   * for ghs-tabs component and accessibility purposes.
   */
  @property({ type: String, attribute: 'unique-id', reflect: true })
  uniqueId: string = Math.floor(Math.random() * 10000).toString();

  @state() isOpen = false;

  setNavAttributes(): void {
    this.setAttribute('aria-selected', this.active ? 'true' : 'false');
    this.setAttribute('aria-controls', `${this.uniqueId}-info`);
    this.setAttribute('id', `${this.uniqueId}-button`);
    this.setAttribute('role', 'tab');
  }

  updated() {
    this.setNavAttributes();
  }

  render(): TemplateResult {
    const isActive = this.active ? 'active' : 'inactive';

    return html`
      <div class="tab-link ${isActive}">
        <span class="tab-link-label ${isActive}">
          <a href="${this.url}">${this.label}</a>
        </span>
      </div>
    `;
  }
}
